export const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === "[::1]" ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
)

export const getIdColegio = async () => {
  try {
    const response = await fetch("/subdominios.json")
    const subdomains = await response.json()

    // Obtener el subdominio desde la URL
    const hostname = window.location.hostname
    const subdomainFromUrl = hostname.split(".")[0]

    // Retorna el id_colegio correspondiente o -1 si no se encuentra
    return subdomains[subdomainFromUrl] || -1
  } catch (error) {
    console.error("Error cargando el archivo de subdominios:", error)
    return -1
  }
}
